export default "__VITE_ASSET__64d8b1bb__"